export default "__VITE_ASSET__yInJdoy9__"